import { render } from "./CreateSubCategoryDialog.vue?vue&type=template&id=0ecee066"
import script from "./CreateSubCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateSubCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__